<template>
  <div class="l-row">
    <form-group :columns="columns || 2" label="Data limite para resgate de pedidos" v-bind:class="areaClass">
      <el-date-picker
        class="order-retrieve-date"
        v-model="orderConfigs.retrieveDate"
        type="date"
        placeholder="Data Limite"
        format="dd/MM/yyyy">
      </el-date-picker>
      <small class="form-help">Pedidos com a data de criação no marketplace anterior a configurada não serão resgatados para o Hub.</small>
    </form-group>
  </div>
</template>

<script>
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({}),
    props: {
      orderConfigs: {
        type: Object,
        required: true
      },
      columns: {
        type: Number,
        required: false
      }
    },
    computed: {
      areaClass () {
        return {
          'order-retrieve-date-area': !!this.columns
        }
      }
    },
    components: {
      FormGroup
    }
  }
</script>

<style lang="sass" scoped>
  .order-retrieve-date-area
    margin-left: 10px

  .order-retrieve-date
    padding: 0
</style>



// WEBPACK FOOTER //
// OrderRetrieveDateConfiguration.vue?31fe9ed1